<script>
	import {External, M} from '../../external';
	import {onMount} from 'svelte';
	import NoDataPlaceholder from "../../Common/NoDataPlaceholder.svelte";

	export let contact;

	External.$.fn.scheduledEvents = External.BookingCommon.scheduledEvents;
	let itemsWrapper;
	let noAppointments = false;

	const appointments = {
		init: () => {
			External.Tools.makeWebsiteRequest({
				action: 'getBookedEvents',
				data: {
					filters: JSON.stringify({contactId: contact.data.id})
				},
				onOk: function (result) {
					// this should move to Svelte someday...
					const $wrapper = External.$(itemsWrapper);

					if (!result || !result.data || result.data.items.length === 0) {
						$wrapper.empty();
						noAppointments = true;
						return;
					}

					noAppointments = false;

					$wrapper.scheduledEvents({
						data: result.data.items
					});

					$wrapper.find('[data-action="cancelEvent"]').on('click', function (e) {
						External.BookingCommon.cancelBooking(e, function () {
							$wrapper.empty();
							appointments.init();
						});
					});
				}
			});
		}
	};

	onMount(() => {
		appointments.init();
	});
</script>

{#if noAppointments}
	<NoDataPlaceholder message={M.NO_APPOINTMENTS}/>
{/if}

<div class="scheduledBookings" style="overflow: hidden">
	<div bind:this={itemsWrapper} class="items-wrapper"></div>
</div>
